import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'bytes',
    standalone: true,
})
export class BytesPipe implements PipeTransform {
    transform(arg: number, args?: any[]): any {
        return this.formatBytes(arg);
    }

    formatBytes(a, b = 2) {
        // From https://stackoverflow.com/a/18650828/550653
        if (0 === a) return '0 Bytes';
        const c = 0 > b ? 0 : b,
            d = Math.floor(Math.log(a) / Math.log(1024));
        return (
            parseFloat((a / Math.pow(1024, d)).toFixed(c)) +
            ' ' +
            ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][d]
        );
    }
}
